import CardWithTitleAndButton from 'components/CardWithTitleAndButton';
import ButtonV2 from 'components/common/ButtonV2';
import FormikInputFieldV2 from 'components/Fields/FormikInputFieldV2';
import ReactSelect from 'components/Fields/ReactSelect';
import { authContext } from 'contexts/AuthContext';
import { Field } from 'formik';
import React, { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { Col, Row } from 'reactstrap';
import { axiosPost } from 'services';
import { currencyUnitData } from 'utils/constants';

const ChargesSection = ({
  values,
  isChargeFormDisabled,
  refetchOrderData,
  onOrderUpdated,
}) => {
  const { auth } = useContext(authContext);

  const [loadingCharges, setLoadingCharges] = useState(false);

  const onClickUpdateCharges = async () => {
    if (isChargeFormDisabled) return;

    try {
      const hasFreight =
        values?.freightValue !== undefined &&
        values?.freightValue !== null &&
        values?.freightValue !== '';
      const hasLoading =
        values?.loadingValue !== undefined &&
        values?.loadingValue !== null &&
        values?.loadingValue !== '';

      if (hasFreight && hasLoading) {
        setLoadingCharges(true);
        const resp = await axiosPost(
          `${process.env.REACT_APP_REST_API_ENDPOINT}order/update-loading-charges/${values?.id}`,
          {
            freightValue: Number(values?.freightValue),
            loadingValue: Number(values?.loadingValue),
          },
          {},
          auth,
        );
        if (resp.isSuccessful) {
          toast.success('Charges Updated Successfully.');
          if (refetchOrderData) {
            await refetchOrderData();
          }
          if (onOrderUpdated) {
            await onOrderUpdated();
          }
        }
      } else {
        toast.error('Please enter both charges.');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingCharges(false);
    }
  };

  return (
    <CardWithTitleAndButton
      title="Charges"
      className={isChargeFormDisabled ? 'charges-section-disabled' : ''}
    >
      <Row>
        <Col>
          <Row>
            <Col>
              <Field
                label="Freight Charges (Rs/kg)"
                name="freightValue"
                type="number"
                component={FormikInputFieldV2}
                placeholder="Enter rate"
                required
                value={values.freightValue}
                disabled={isChargeFormDisabled}
              />
            </Col>
            <Col sm={3} className="unit-column-v2">
              <Field
                label=""
                name="rateUnit"
                type="select"
                component={ReactSelect}
                data={currencyUnitData}
                keys={{ id: 'id', label: 'label' }}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.label}
                value={values.rateUnit}
                isDisabled
              />
            </Col>
          </Row>
        </Col>
        <Col>
          <Row>
            <Col>
              <Field
                label="Loading Charges"
                name="loadingValue"
                type="number"
                component={FormikInputFieldV2}
                placeholder="Enter rate"
                required
                value={values.loadingValue}
                disabled={isChargeFormDisabled}
              />
            </Col>
            <Col sm={3} className="unit-column-v2">
              <Field
                label=""
                name="rateUnit"
                type="select"
                component={ReactSelect}
                data={currencyUnitData}
                keys={{ id: 'id', label: 'label' }}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.label}
                value={values.rateUnit}
                isDisabled
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <div className="d-flex justify-content-end mt-3">
        <ButtonV2
          color="primary"
          key="update-charges"
          onClick={onClickUpdateCharges}
          size="sm"
          style={{
            borderRadius: '4px !important',
          }}
          className="border-radius-4"
          disabled={isChargeFormDisabled || loadingCharges}
        >
          {loadingCharges ? 'Saving...' : 'Update Charges'}
        </ButtonV2>
      </div>
    </CardWithTitleAndButton>
  );
};

export default ChargesSection;
